import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Header.css';
import { useActiveSubscription } from '../hooks/useActiveSubscription';

const Header: React.FC = () => {
  const { user } = useAuth();
  const location = useLocation();
  const { hasActiveSub } = useActiveSubscription();
  const hideEmail =
    location.pathname.startsWith('/ev') ||
    location.pathname.startsWith('/events') ||
    location.pathname.startsWith('/profile');
  const isLanding = location.pathname === '/';
  const isOnboarding = location.pathname.startsWith('/onboarding');
  const isLogin = location.pathname.startsWith('/login');
  const logoTarget = user && hasActiveSub ? '/ev' : '/';

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <Link to={logoTarget} className="logo">
            <div className="logo-icon">PK</div>
            <span className="logo-text">PIKM</span>
          </Link>
          {!isOnboarding && !isLogin && (
            <nav className="nav">
              {!user && !isLanding && <Link to="/" className="nav-link">Home</Link>}
              {user ? (
                <>
                  <Link to="/ev" className="nav-link">EV</Link>
                  {hasActiveSub && <Link to="/events" className="nav-link">Events</Link>}
                  <Link to="/profile" className="nav-link">Profile</Link>
                  <div className="user-menu">
                    {!hideEmail && (
                      <span className="user-email">{user.email}</span>
                    )}
                  </div>
                </>
              ) : (
                <>
                  <Link to="/login" className="nav-link plausible-event-name=header-click-login">Log In</Link>
                  <Link to="/onboarding" className="nav-link signup-link plausible-event-name=header-click-sign-up">Sign Up</Link>
                </>
              )}
            </nav>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header; 